import { ButtonProps } from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useCallback, useMemo, useState } from "react";
import { useMutation } from "react-query";
import { Dialog } from "../../../components/Dialog";
import { useToast } from "../../../hooks/useToast";
import { createNote } from "../../../services/person";
import { queryClient } from "../../../services/queryClient";
import { Person } from "../../../types/person";

type AddNoteProps = {
  person: Person;
  open: boolean;
  onClose: () => void;
};

export function AddNote({ person, open, onClose }: AddNoteProps) {
  const [note, setNote] = useState<string>();

  const toast = useToast();

  const handleClose = useCallback(() => {
    onClose();
    setNote("");
  }, [onClose]);

  const newNote = useMutation(
    async () => {
      const objectRequestData = {
        id_pessoa: person.id_pessoa,
        nota: note,
      };
      const response = await createNote(objectRequestData);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Nota criada com sucesso!", { severity: "success" });
        queryClient.invalidateQueries(["notes"]);
        handleClose();
      },
      onError: () => {
        toast.show("Erro ao criar a nota!", { severity: "error" });
      },
    }
  );

  const handleSave = useCallback(async () => {
    await newNote.mutateAsync();
  }, [newNote]);

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        disabled: newNote.isLoading,
        children: "Voltar",
        onClick: handleClose,
      },
      {
        disabled: newNote.isLoading,
        children: newNote.isLoading ? "Enviado solicitação..." : "Salvar",
        variant: "contained",
        onClick: handleSave,
      },
    ];
  }, [newNote, handleSave, handleClose]);

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      title="Nova nota"
      open={open}
      actions={actions}
      onClose={handleClose}
    >
      <TextField
        margin="normal"
        autoFocus
        rows={5}
        multiline
        label="Texto"
        onChange={({ target: { value } }) => setNote(value)}
        fullWidth
        size="small"
        value={note}
      />
    </Dialog>
  );
}
